import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// import ChangeViewArrayWithoutRouter from '../ChangeViewArrayWithoutRouter';
import ChangeViewArray from '../ChangeViewArray';

import DocIcon from '../../icons/DocIcon';
import VideoIcon from '../../icons/VideoIcon';
import RateIcon from '../../icons/RateIcon';
import OutsourcingIcon from '../../icons/OutsourcingIcon';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import CardManager from '../CardManager';
import axios from 'axios';
import ShareIcon from '../../icons/ShareIcon';
import PrimaryButton from '../PrimaryButton';
import AllAppsTile from '../Applications/AllAppsTile';
import AllAppsTable from '../Applications/AllAppsTable';
import SkeletonReviewContent from '../Skeleton/SkeletonReviewContent';
import SkeletonCardTable from '../Skeleton/SkeletonCardTable';
import SkeletonCardTile from '../Skeleton/SkeletonCardTile';
import translate from '../../other/translate.json';
import Link from '@material-ui/core/Link';
import mail from '../../other/config.json';
import Tooltip from '@material-ui/core/Tooltip';
import Snackbar from '@material-ui/core/Snackbar';
import Avatar from '@material-ui/core/Avatar';
import config from '../../other/config';
const { serverAPI } = config;

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(60, 60, 86, 0.8)',
    color: '#FFFFFF',
    boxShadow: 'none',
    padding: 12,
    borderRadius: 8,
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
  },
}))(Tooltip);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Grid
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: '100%' }}
    >
      {value === index && (
        <Box p={3} style={{ padding: 0, backgroundColor: 'transparent' }} >
          <Grid id="a157" style={{ marginTop: 52 }}>{children}</Grid>
        </Box>
      )}
    </Grid>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function CloudContent(props) {
  let { bank } = useParams();
  let { IsRu, cloudBasket, setBasketCloud, basketChips, appBasket, setAppBasket, language } = props;
  let lang = IsRu ? 'Ru' : 'En';
  let mailTo1 = `mailto:?subject=${mail['subjectShare']}&body=${encodeURIComponent(mail[`bodyShare_${lang}`]) + ' ' + window.location.href}`
  const classes = useStyles();
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [value, setValue] = React.useState(0);
  const [bankinfo, setBankinfo] = useState([]);
  const [cardArr, setCardArr] = useState({ neededApps: [], RecommendedApps: [] });
  const [loading, setloading] = React.useState(true);
  const [snackbar, _snackbar] = React.useState(false);
  let [view, _view] = useState(localStorage.getItem('view') || 'table')
  let [checkAll, setCheckAll] = useState(false); // codeerr что-то не то у нас checkall везде false
  function handleStrockList(index) {
    setView(index)
  };

  function setView(view) {
    _view(view)
    localStorage.setItem('view', view)
  }

  function closeSnackbar(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    _snackbar(false);
  };

  function setCloudBasketSnackbar() {
    _snackbar(true);
    setBasketCloud(cardArr.neededApps.concat(cardArr.RecommendedApps).map(el => el.ID), bankinfo.ID)
  }

  // useEffect(() => {
  //   view === 'tile' ?
  //     history.push({ search: history.location.search.replace('?view=table', '?view=tile') }) :
  //     history.push({ search: history.location.search.replace('?view=tile', '?view=table') })
  // }, [view]);

  useEffect(() => {
    let didCancel = false;
    async function fetchData() {
      setloading(true)
      const _bankinfo = await axios.get(`${serverAPI}/bankinfo/${bank}/4/${language}`)

      // const _card1 = await axios.get(`${serverAPI}/cloud_v2/${bank}/${props.selectedIndex}`)

      if (!didCancel) {
        if (_bankinfo && _bankinfo.data.length > 0 && _bankinfo.data) {
          setloading(false)
          setBankinfo(_bankinfo.data[0])

          const _card = await axios.get(`${serverAPI}/cloudv/${_bankinfo.data[0].ID}/${language}`)
          if (_card && _card.data) {
            setloading(false)
            setCardArr(_card.data)
          }
        } else {
          props.setErr(true)
        }
      }
    }
    fetchData();
    return () => {
      didCancel = true;
    }
  }, [bank, language]);

  useEffect(() => {
    if (window.innerWidth < 1366 && view === 'table') {
      setSelectedIndex(0)
      _view('tile')
    }
  }, [window.innerWidth]);

  function handleChangeSolutionTabs(event, newValue) {
    setValue(newValue);
  };

  const CloudTabs = withStyles({
    indicator: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      height: 3,

      '& > span': {
        // maxWidth: 40,
        width: '100%',
        height: 3,
        backgroundColor: '#24262A',
      },
    },
  })((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

  const CloudTab = withStyles((theme) => ({
    root: {
      textTransform: 'none',
      color: '#24262A',
      fontWeight: '400', // theme.typography.fontWeightRegular,
      fontSize: '16px', // theme.typography.pxToRem(15),
      // marginRight: theme.spacing(1),
      borderBottom: '1px solid #BCBBD0',

      '&:focus': {
        opacity: 1,
      },

      '&:first-child': {
        minWidth: 75,
      }
    },
  }))((props) => <Tab disableRipple {...props} />);

  return (
    <Grid
      container
      direction="column"
      justify="flex-start"
      alignItems="flex-start"
    // style={{ outline: '1px solid blue' }}
    >
      <Grid /* panel/title */
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        style={{ minHeight: 57 }}
      >
        <Grid item style={{ maxWidth: 865 }}>
          <Typography className={classes.Header}>{bankinfo && bankinfo[`Title`]}</Typography>
        </Grid>

        <Grid item>
          <CloudTabs
            value={value}
            onChange={handleChangeSolutionTabs}
            aria-label="simple tabs example"
          >
            <CloudTab label={translate.Words[`Overview${lang}`]} {...a11yProps(0)} />
            {bankinfo && bankinfo[`Managers`] ? <CloudTab label={IsRu ? "Менеджеры проекта" : "Managers"} {...a11yProps(1)} /> : " "}
          </CloudTabs>
        </Grid>
        {/* <Link href="/basket" onClick={preventDefault} className={classes.Body1}>Сохранённые комплектации</Link> */}
      </Grid>

      <TabPanel value={value} index={0}>
        <Grid /* actions/subtitle */ container>
          {
            loading === true
              ?
              <SkeletonReviewContent />
              :
              <Grid item container direction="row" justify="space-between">
                <Grid item className={classes.serviceDescription}>
                  <Typography component="p" className={classes.Body1}>
                    <div dangerouslySetInnerHTML={{ __html: bankinfo[`HTMLContent`] }}></div>
                  </Typography>
                </Grid>

                <Grid item className={classes.SideActions}>
                  {
                    IsRu && bankinfo && bankinfo.AboutPath && bankinfo.AboutPath.length > 4
                      ?
                      <Link href={`${serverAPI}/${bankinfo.HashCode}/about/${bankinfo.AboutPath}`} target="_blank">
                        <Grid item container direction="row" className={classes.SideAction}>
                          <DocIcon fill={'#BCBBD0'} />

                          <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                            Информация по каталогу
                          </Typography>
                        </Grid>
                      </Link>
                      :
                      ''
                  }

                  {
                    IsRu && bankinfo && bankinfo.VideoPath && bankinfo.VideoPath.length > 4
                      ?
                      <Link href={`${serverAPI}/${bankinfo.HashCode}/video/${bankinfo.VideoPath}`} rel="noopener noreferrer" target="_blank">
                        <Grid item container direction="row" style={{ marginTop: 20 }}>
                          <VideoIcon fill={'#BCBBD0'} />
                          <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                            Видео презентация
                          </Typography>
                        </Grid>
                      </Link>
                      :
                      ''
                  }

                  {
                    bankinfo && bankinfo.Outsourcing && bankinfo.Outsourcing.length > 4
                      ?
                      <Link href={bankinfo.Outsourcing} rel="noopener noreferrer" target="_blank">
                        <Grid item container direction="row" style={{ marginTop: 20 }}>
                          <RateIcon fill={'#BCBBD0'} />
                          <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                            {translate.Words[`Outsourcing_${lang}`]}
                          </Typography>
                        </Grid>
                      </Link>
                      :
                      ''
                  }

                  {
                    bankinfo && bankinfo.Tariff && bankinfo.Tariff.length > 4
                      ?
                      <Link href={bankinfo.Tariff} rel="noopener noreferrer" target="_blank">
                        <Grid item container direction="row" style={{ marginTop: 20 }}>
                          <OutsourcingIcon fill={'#BCBBD0'} />
                          <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                            {translate.Words[`PricePlans_${lang}`]}
                          </Typography>
                        </Grid>
                      </Link>
                      :
                      ''
                  }
                </Grid>
              </Grid>
          }

          <Grid item style={{ marginTop: 9, padding: '11px 0px' }}>
            <Grid item container direction="row" justify="flex-start" alignItems="center">
              <Grid item style={{ marginRight: 16 }}>
                <PrimaryButton
                  height={55}
                  onClick={setCloudBasketSnackbar}
                  disabled={                // это что за покемон????? начало codeerr
                    loading === true
                      ?
                      ''
                      :
                      cardArr.МarketApps === undefined
                        ?
                        ''
                        :
                        cardArr.RecommendedApps.length === 0
                          &&
                          cardArr.neededApps.length === 0
                          &&
                          cardArr.МarketApps.length === 0
                          ?
                          true
                          :
                          false
                  }  // это что за покемон????? конец codeerr
                  text={cloudBasket.includes(bankinfo.ID) ? translate.Words[`RemoveFromBasket${lang}`] : translate.Words[`AddTobasket${lang}`]}
                />
                {/* RemoveFromBasket${lang}*/}
              </Grid>

              <CustomTooltip title={lang === 'Ru' ? 'Отправьте ссылку' : "Share the link"}>
                <IconButton aria-label="delete" style={{ background: '#FFFFFF', boxShadow: '4px 4px 20px rgba(68, 113, 209, 0.12)', height: 48 }} className={classes.margin}>
                  <a style={{ textDecoration: 'none' }} href={mailTo1}>
                    <ShareIcon fill={'#BCBBD0'} />
                  </a>
                </IconButton>
              </CustomTooltip>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} className={classes.block} style={{ marginTop: 34 }}>
          {cardArr.neededApps.length + cardArr.RecommendedApps.length > 0 ?
            <Grid item container alignItems="center" style={{ height: 108 }}>
              <Grid
                item
                // key={props.ml}
                className={classes.search}
                style={{ flexGrow: 1, padding: '3px 0px' }}
              >
                <Typography className={classes.Title2}>{translate.Words[`Applications_${lang}`]} </Typography>
              </Grid>

              <Grid item className={classes.cntrChangeView}>
                {/* <ChangeViewArrayWithoutRouter selected={selectedIndex} handleStrockList={handleStrockList} /> */}
                <ChangeViewArray selected={view === 'tile' ? 1 : 0} handleView={handleStrockList} />
              </Grid>
            </Grid>
            : ''}

          {/* {selectedIndex === 1 ? <> */}
          <Grid item container>
            {
              cardArr && cardArr.neededApps && cardArr.neededApps.length > 0
                ?
                <Grid item container>
                  <Grid item container alignItems="center" style={{ height: 108 }}>
                    <Typography className={classes.Title3}>{translate.Words[`RequiredApplications_${lang}`]} </Typography>
                  </Grid>

                  <Grid item container spacing={3}>
                    {
                      cardArr && cardArr.neededApps
                        ?
                        view === 'tile' ?
                          loading === true
                            ?
                            <SkeletonCardTable />
                            :
                            <AllAppsTable checkAll={false} setCheckAll={setCheckAll} basket={true} type={'applications'} readLink={bankinfo && bankinfo.length > 0 && bankinfo.readLink} language={language} basketChips={basketChips} setAppBasket={setAppBasket} IsRu={IsRu} setIsRu={props.setIsRu} cardArr={cardArr.neededApps} bank={props.bank} />
                          :
                          loading === true
                            ?
                            <SkeletonCardTile />
                            :
                            <AllAppsTile checkAll={false} setCheckAll={setCheckAll} basket={true} type={'applications'} readLink={bankinfo && bankinfo.length > 0 && bankinfo.readLink} language={language} basketChips={basketChips} setAppBasket={setAppBasket} IsRu={IsRu} setIsRu={props.setIsRu} cardArr={cardArr.neededApps} bank={props.bank} />

                        :
                        ''
                    }
                  </Grid>
                </Grid>
                :
                ''
            }

            {
              cardArr && cardArr.RecommendedApps && cardArr.RecommendedApps.length > 0
                ?
                <Grid item container>
                  <Grid item container alignItems="center" style={{ height: 108 }}>
                    <Typography className={classes.Title3}>{translate.Words[`RecommendedApplications${lang}`]} </Typography>
                  </Grid>

                  <Grid item container spacing={3}>
                    {
                      view === 'tile' ?
                        // cardArr.RecommendedApps.map((item) => {
                        //   return (
                        loading === true
                          ?
                          <SkeletonCardTable />
                          :
                          <AllAppsTable checkAll={false} setCheckAll={setCheckAll} basket={true} type={'cloud'} readLink={bankinfo && bankinfo.length > 0 && bankinfo.readLink} language={language} basketChips={basketChips} setAppBasket={setAppBasket} IsRu={IsRu} setIsRu={props.setIsRu} cardArr={cardArr.RecommendedApps} bank={props.bank} />
                        :
                        loading === true
                          ?
                          <SkeletonCardTile />
                          :
                          <AllAppsTile checkAll={false} setCheckAll={setCheckAll} basket={true} type={'cloud'} readLink={bankinfo && bankinfo.length > 0 && bankinfo.readLink} language={language} basketChips={basketChips} setAppBasket={setAppBasket} IsRu={IsRu} setIsRu={props.setIsRu} cardArr={cardArr.RecommendedApps} bank={props.bank} />

                      //     <Grid item style={{ width: 336 }} key={`${item.ID}_grid_key`} >
                      //       <SolutionListCard
                      //         preUrl={'cloud'}
                      //         basketChips={basketChips}
                      //         wide={false}
                      //         readLink={bankinfo && bankinfo.length > 0 && bankinfo.readLink}
                      //         key={`solition_${item.ID}`}
                      //         data={item}
                      //         wide={false}
                      //         IsRu={IsRu}
                      //         setSolutionsBasket={setAppBasket}
                      //         solutionBasket={solutionBasket}
                      //         solutionsBasketChips={basketChips}
                      //       />
                      //     </Grid>
                      //   )
                      // })
                      // :
                      // <AllAppsTile
                      //   readLink={bankinfo && bankinfo.length > 0 && bankinfo.readLink}
                      //   basketChips={basketChips} appBasket={appBasket} setAppBasket={setAppBasket} IsRu={IsRu} setIsRu={props.setIsRu} cardArr={cardArr.RecommendedApps} bank={props.bank} />

                    }
                  </Grid>
                </Grid>
                :
                ''
            }

            {
              cardArr && cardArr.МarketApps && cardArr.МarketApps.length > 0
                ?
                <Grid item container style={{ /* outline: '1px solid blue', */ }}>
                  <Grid item container alignItems="center" style={{ height: 108 }}>
                    <Typography className={classes.Title3}>{translate.Words[`WeRecommendWithThisService${lang}`]}</Typography>
                  </Grid>

                  {
                    selectedIndex === 1
                      ?
                      <Grid item container spacing={3}>
                        {
                          cardArr && cardArr.МarketApps && cardArr.МarketApps.length > 0
                            ?
                            <AllAppsTable checkAll={false} setCheckAll={setCheckAll} basket={true} readLink={bankinfo && bankinfo.length > 0 && bankinfo.readLink} language={language} basketChips={basketChips} setAppBasket={setAppBasket} IsRu={IsRu} setIsRu={props.setIsRu} cardArr={cardArr.МarketApps} bank={props.bank} />
                            :
                            <AllAppsTile
                              checkAll={false} setCheckAll={setCheckAll}
                              basket={true} readLink={bankinfo && bankinfo.length > 0 && bankinfo.readLink} language={language} basketChips={basketChips} setAppBasket={setAppBasket} IsRu={IsRu} setIsRu={props.setIsRu} cardArr={cardArr.МarketApps} bank={props.bank} />
                        }
                      </Grid>
                      :
                      <AllAppsTile
                        checkAll={false} setCheckAll={setCheckAll}
                        basket={true}
                        readLink={bankinfo && bankinfo.length > 0 && bankinfo.readLink}
                        basketChips={basketChips}
                        appBasket={appBasket}
                        setAppBasket={setAppBasket}
                        IsRu={IsRu}
                        setIsRu={props.setIsRu}
                        cardArr={cardArr.МarketApps}
                        bank={props.bank}
                      />
                  }
                </Grid>
                :
                ''
            }
          </Grid>
          {/* </> : */}
        </Grid>

        <div>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            open={snackbar}
            autoHideDuration={3000}
            onClose={closeSnackbar}
            // message="Приложение доавлено в корзину"
            className={classes.root}
          >
            <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="center"
              className={classes.snackbarPostroot}
            >
              <Avatar style={{ height: 48, width: 48, background: 'rgba(255, 255, 255, 0.2)' }}>
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.75488 12.2105L10.7894 16L19.7549 7" stroke="white" stroke-width="2" stroke-linecap="round" />
                </svg>
              </Avatar>
              {
                cloudBasket.includes(bankinfo.ID)
                  ?
                  <Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF' }}>
                    {translate.Words[`AdtoCartService_${lang}`]} </Typography>
                  :
                  <Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF' }}>
                    {translate.Words[`RemoveCartService_${lang}`]}  </Typography>
              }
            </Grid>
          </Snackbar>
        </div>
      </TabPanel >

      {
        bankinfo && bankinfo[`Managers`]
          ?
          <TabPanel value={value} index={1}>
            <Grid
              container
              direction="column"
              justify="flex-start"
              alignItems="flex-start"
              className={classes.container}
            >
              <Grid item container className={classes.block} style={{ marginTop: 82 }}>
                <Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader} style={{ textAlign: 'center', width: '100%' }}>
                  {translate.Words[`ReadytoAnswerYourQuestions${lang}`]}:
                </Typography>

                <Grid
                  item
                  container
                  direction="row"
                  justify="center"
                  alignItems="flex-start"
                  spacing={3}
                  style={{ marginTop: 40 }}
                >

                  {
                    bankinfo[`Managers`] ? bankinfo[`Managers`].split(';#;').map((item, index) => (
                      <Grid item>
                        <CardManager data={item} />
                      </Grid>
                    ))
                      :
                      ''
                  }
                </Grid>
              </Grid>
            </Grid>
          </TabPanel>
          :
          ''
      }
    </Grid>
  );
}

const useStyles = makeStyles(theme => ({
  // root: {
  // 	display: "flex"
  // },

  content: {
    flexGrow: 1,
    padding: 0,
    paddingTop: theme.spacing(3),
    marginTop: theme.spacing(12),
    // backgroundColor: 'inherit'
  },

  Header: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '40px',
    lineHeight: '50px',
    color: '#000000'
  },

  contentHeader: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '28px',
    lineHeight: '40px',
    textAlign: 'center',
    color: '#000000'
  },

  container: {
    margin: '72px auto 0',
    '&:first-child': {
      margin: '0 auto'
    },
    // [theme.breakpoints.down(696)]: {
    //   maxWidth: 'calc(312px * 1)',
    // },
    // [theme.breakpoints.between(696, 1032)]: {
    //   maxWidth: 'calc(323px * 2)',
    // },
    // [theme.breakpoints.between(1032, 1366)]: {
    //   maxWidth: 'calc(330px * 3)',
    // },
    // [theme.breakpoints.between(1366, 1702)]: {
    //   maxWidth: 'calc(327px * 3)',
    // },
    // [theme.breakpoints.up(1702)]: {
    //   maxWidth: 'calc(330px * 4)',
    // }
  },

  tHeader: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2',
    fontWeight: 400
  },

  search: {
    position: 'relative',
    borderRadius: 24,
    backgroundColor: 'transparent',
    marginLeft: 0,
    marginRight: theme.spacing(1),
    width: 'auto',
    height: 48,

    [theme.breakpoints.down(1366)]: {
      backgroundColor: 'transparent'
    }
  },

  root: {
    flexGrow: 1
  },

  cntrChangeView: {
    [theme.breakpoints.down(1366)]: {
      display: 'none'
    }
  },

  Body1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#24262A',

    '& * > a': {
      color: '#24262A !important',
      textDecoration: 'none',
      borderBottom: '1px solid rgba(0, 0, 0, 0.4)',

      '&:hover': {
        color: '#2050FF !important',
        textDecoration: 'none',
        borderBottom: '1px solid #2050FF',
      },

      '& > span': {
        color: 'inherit !important',
        textDecoration: 'none !important',

        '& > font': {
          color: 'inherit !important',
          textDecoration: 'none !important',

          '&:hover': {
            color: 'inherit !important',
            textDecoration: 'none !important',
          }
        }
      }
    },
  },

  Title2: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '28px',
    lineHeight: '40px',
    color: '#000000'
  },

  Title3: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '24px',
    lineHeight: '32px',
    color: '#24262A',
  },

  Title4: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '28px',
    color: '#000000',
  },

  SideActions: {
    minWidth: 246,
    padding: '12px 26px',
    // width: 313,
    marginTop: 17,

    [theme.breakpoints.down(1032)]: {
      padding: 0,
      marginBottom: 60,
    }
  },

  SideAction: {
    height: 28
  },

  snackbarPostroot: {
    padding: 24,
    borderRadius: '16px',
    background: 'rgba(60, 60, 86, 0.9)',
  },

  serviceDescription: {
    padding: '11px 0px',
    maxWidth: 865,

    [theme.breakpoints.between(1032, 1702)]: {
      maxWidth: 670,
    },

    [theme.breakpoints.down(1032)]: {
      maxWidth: '100%'
    },
  }
}));